<template lang="html">
  <div>
    <gameHeader :book="bookTitle"
                :unit="unitTitle"
                :topic="topicTitle"
                :description="subTopic.description"/>
    <div class="yellow-line">
    </div>
    <div class="box-content shadow-box-side box-content-border box-content-border-none relative hidden gview" :class="{ 'size--ec-st': isEC }">

      <transition name="fade">
        <div class="unit-challenge__block container wrap align-center animation-fade" v-show="firstTime">
          <div class="unit-challenge__block__center container align-center animation-bottom">
            <div class="icon-img">
              <img src="@/assets/img/icon-books.svg" width="80" alt="Minds" class="">
            </div>
            <div class="flex-grow-1 flex-basis-600">
              <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</p>
            </div>
            <div class="">
              <button type="button" name="button" class="btn btn-full btn-rounded gradient-yellow color-orange-dark" @click="firstTime = false">INICIAR ESTUDO</button>
            </div>
          </div>
        </div>
      </transition>

      <slot :topic="topic" :subTopic="subTopic"/>
    </div>
    <gameFooter :questions="subTopic.type !== 'english-central' ? subTopic.exercise.questions.map((q, index) => ({ ...q, _id: String(index)})) : []"
                :length="subTopic.type !== 'english-central' ? subTopic.exercise.questions.length : 0"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { toArray } from '@/store/firebase'

export default {
  name: 'Exercise',
  data() {
    return {
      firstTime: false
    }
  },
  computed: {
    ...mapGetters({
      _topic_: 'topic/get',
      _subTopic_: 'subTopic/get',
      isReview: 'isReview',
      isEC: 'isEC',
      isSpeakUp: 'isSpeakUp',
      isSpeakUpFeedback: 'isSpeakUpFeedback',
      speakUp: 'speakup/getSpeakUp',
      subTopicSpeakUp: 'speakup/getSubTopic',
      speakUpFeedback: 'speakupFeedback/getSpeakUp',
      subTopicSpeakUpFeedback: 'speakupFeedback/getSubTopic',
      student: 'student/GET',
      teensTopic: 'teens/GET_TOPIC',
      teensSubTopic: 'teens/GET_SUBTOPIC',
    }),
    bookTitle () {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback)
        return this.$route.params.book ? this.$route.params.book : 'Book Test'

      if (this.isSpeakUp)
        return this.speakUp.book_name

      return this.speakUpFeedback.book_name
    },
    unitTitle () {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback)
        return this.$route.params.unit ? this.$route.params.unit.toString() : '0'

      return ''
    },
    topicTitle () {
      if (!this.isSpeakUp && !this.isSpeakUpFeedback)
        return this.$route.params.topic ? this.$route.params.topic : 'Topic Test'

      if (this.isSpeakUp)
        return this.speakUp.lesson_name

      return this.speakUpFeedback.lesson_name
    },
    topic () {
      if (!!this.student.teens)
        return this.teensTopic

      if (this.isSpeakUp)
        return this.speakUp

      if (this.isSpeakupFeedback)
        return this.speakUpFeedback

      if (!this.isReview)
        return this._topic_

      let topic = this._topic_

      topic.finished = false
      topic.percent = 0
      topic.score = 0

      return topic
    },
    subTopic () {
      if (!!this.student.teens)
        return this.teensSubTopic

      if (this.isSpeakUp) {
        return {
          ...this.subTopicSpeakUp,
          exercise: {
            ...this.subTopicSpeakUp.exercise,
            questions: this.subTopicSpeakUp.exercise.questions.map((q, index) => ({
              ...q,
              _id: String(index)
            }))
          }
        }
      }

      if (this.isSpeakUpFeedback) {
        return {
          ...this.subTopicSpeakUpFeedback,
          exercise: {
            ...this.subTopicSpeakUpFeedback.exercise,
            questions: this.subTopicSpeakUpFeedback.exercise.questions.map((q, index) => ({
              ...q,
              _id: String(index)
            }))
          }
        }
      }

      if (!this.isReview)
        return this._subTopic_

      let topic    = this.topic,
          subTopic = this._subTopic_

      if (subTopic.type !== 'english-central') {
        subTopic.exercise.questions.forEach((q, index) => {
          if (q.answers) {
            q.answers.forEach((a, ind) => {
              this.$set(subTopic.exercise.questions[index].answers[ind], 'selected', false)
              if (subTopic.exercise.questions[index].answers[ind].hasOwnProperty('pair1')) {
                this.$delete(subTopic.exercise.questions[index].answers[ind], 'pair1')
                this.$delete(subTopic.exercise.questions[index].answers[ind], 'pair2')
              }
            })
          }

          if (q.answer) {
            q.answer = ''
          }

          if (subTopic.exercise.questions[index].categories) {
            for (const ind in subTopic.exercise.questions[index].categories) {
              this.$set(subTopic.exercise.questions[index].categories[ind], 'answers', null)
            }
          }

          this.$set(subTopic.exercise.questions[index], 'hit', false)
          this.$set(subTopic.exercise.questions[index], 'answered', false)
          if (subTopic.exercise.questions[index].score)
            this.$set(subTopic.exercise.questions, 'score', 0)
          if (subTopic.exercise.questions[index].answer)
            this.$set(subTopic.exercise.questions[index], 'answer', 0)
        })

        subTopic.finished = false
        subTopic.points = 0
      }

      return subTopic
    }
  }
}
</script>

<style lang="scss">
@import './src/assets/css/components/_unitChallenge';
</style>



// WEBPACK FOOTER //
// src/components/template/subTopic.vue